@import 'styles/mixins';
@import 'styles/variables';
@import 'styles/blaze/mixins';
@import 'styles/variables';

p.cardInputLabel {
  color: var(--neutral-50);
  font-family: Helvetica Neue;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 137%; /* 19.18px */
  letter-spacing: 0.14px;
  margin-bottom: 4px;
  padding: 0px 10px;
}

.form {
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: 360px;
  display: flex;
  width: 90%;
  overflow: visible;

  @media (max-width: $phoneMaxWidth) {
    width: 100%;
  }

  .paymentElement {
    flex-grow: 1;
    height: fit-content;
    padding: 10px 24px;
  }

  .buttonContainer {
    margin-top: 16px;
    display: flex;
    justify-content: center;

    .buttonContent {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    @include for-phone-only {
      z-index: 1000;
      position: sticky;
      bottom: 0;
      width: 100vw;
      padding: 20px 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: var(--light-100);
    }
  }

  .loadingSpinner {
    margin-right: 4px;
    > div::after {
      background-color: transparent;
    }
  }

  .error {
    margin-top: 16px;
    display: flex;
    color: var(--negative-50);
    text-align: center;
    max-width: 453px;
  }

  @include for-tablet-portrait-min {
    padding: 30px 36px 48px 36px;
    position: relative;
  }
}

.monthlyAnnualToggle {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 0px 24px 32px;
  color: var(--dark-60);
  @include xs-sohne-book;
}

.cardHolderNameAndPromoCodeContainer {
  display: flex;
  gap: 10px;
  justify-content: space-between;
  padding: 0 24px;

  @media (max-width: $phoneMaxWidth) {
    flex-direction: column;
    justify-content: flex-start;
  }
}

.cardHolderInput {
  flex-grow: 1;
  min-width: 168px;
}

.cardHolderInput,
.promoCodeInput {
  --p-colorBackgroundDeemphasize10: #e6e6e6;
  --focusOutline: 0px;
  --p-colorPrimaryAlpha20: hsla(210, 96%, 45%, 25%);
  --p-colorBackgroundContrastAlpha08: rgba(0, 0, 0, 0.08);
  --focusBoxShadow: 0 0 0 3px var(--p-colorPrimaryAlpha20), 0 1px 1px 0 var(--p-colorBackgroundContrastAlpha08);
  --colorDanger: #df1b41;
  --p-colorPrimaryAlpha50: hsla(210, 96%, 45%, 50%);
  --colorTextPlaceholder: #757680;
  margin-bottom: 8px;

  label {
    color: #30313d;
    display: block;
    margin-bottom: 4px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans',
      'Helvetica Neue', sans-serif;
    font-size: 14.88px;
    font-style: normal;
    font-weight: 400;
    line-height: 145%;

    &::placeholder {
      color: var(--colorTextPlaceholder);
    }
  }

  input {
    border-radius: 5px;
    border: 1px solid var(--p-colorBackgroundDeemphasize10);
    background: #fff;
    display: block;
    color: rgb(48, 49, 61);
    width: 100%;
    display: flex;
    padding: 0.75rem;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    font-size: 16px;
    box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.03), 0px 3px 6px 0px rgba(0, 0, 0, 0.02);
    transition: background 0.15s ease, border 0.15s ease, box-shadow 0.15s ease, color 0.15s ease;

    &::placeholder {
      color: var(--colorTextPlaceholder);
    }

    &:focus {
      outline: var(--focusOutline);
      border-color: var(--p-colorPrimaryAlpha50);
      box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(0, 0, 0, 0.02), var(--focusBoxShadow);
    }
  }

  .promoCodeInputRow {
    display: flex;
    gap: 8px;
    align-items: stretch;

    input {
      flex: 1;
    }

    button {
      white-space: nowrap;
      flex-shrink: 0;
    }
  }

  .error {
    display: none;
  }

  &.invalid {
    input {
      color: var(--colorDanger);
      border-color: var(--colorDanger);
      box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(0, 0, 0, 0.02), 0 0 0 1px var(--colorDanger);
    }

    .error {
      font-size: 12px;
      display: block;
      margin-top: 0.25rem;
      display: flex;
      width: 100%;
      color: var(--colorDanger);
    }
  }
}

.authorizationMsg {
  --colorTextSecondary: #6d6e78;
  --fontLineHeight: 1.45;
  --fontSize3Xs: 0.75rem;

  color: var(--colorTextSecondary);
  margin-top: 1.25rem;
  margin-bottom: 10px;
  line-height: var(--fontLineHeight);
  font-size: var(--fontSize3Xs);
  padding: 0px 24px;

  @include for-tablet-portrait-min {
    --fontSize3Xs: 0.7rem;
  }
}

.appliedPillContainer {
  margin-bottom: 8px;
  display: flex;
  align-items: flex-end;
}

.promoAppliedPill {
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--dark-4);
  background: var(--dark-2);
  display: flex;
  gap: 6px;
  height: 48px;
  padding: 8px;

  span {
    color: var(--dark-90);
    text-align: center;
    font-family: Sohne;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 19.2px */
    text-transform: uppercase;
  }

  svg:hover {
    cursor: pointer;
  }
}
